import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import {
  mostraAlertaError,
  mostraAlertaOk,
  mostraAlertaWarning,
} from "../../componentes/alerts/sweetAlert";
import { AxiosImagen, AxiosPrivado } from "../../componentes/axios/Axios";
import GestionUbicacion from "../../componentes/googlemap/GestionUbicacion";
import VerUbicacion from "../../componentes/googlemap/VerUbicacion";
import ModalBootstrap from "../../componentes/modal/ModalBootstrap";
import {
  ClienteImagenEditar,
  ClientesEditar,
  ImagenCliente,
} from "../../configuracion/apiUrls";
import { DireccionConfig } from "../../configuracion/Empresa";
import {
  regexEmail,
  regexIdentidad,
  regexNombreVacio,
  regexRTN,
  regexTelefono
} from "../../configuracion/validaciones";
import { useContextUsuario } from "../../contexto/usuario/UsuarioContext";

const ModalClientes = () => {
  const { token, usuario } = useContextUsuario();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState({
    direccion: DireccionConfig.direccion,
    longitud: DireccionConfig.longitud,
    latitud: DireccionConfig.latitud,
  });
  const [seleccionarDireccion, setSeleccionarDireccion] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formularioClientes, setFormularioClientes] = useState({
    id: usuario.datoPersonales ? usuario.datoPersonales.id : null,
    correo: usuario ? usuario.correo : "",
    rtn: usuario.datoPersonales ? usuario.datoPersonales.rtn : "",
    identidad: usuario.datoPersonales ? usuario.datoPersonales.identidad : "",
    primerNombre: usuario.datoPersonales
      ? usuario.datoPersonales.primerNombre
      : "",
    segundoNombre: usuario.datoPersonales
      ? usuario.datoPersonales.segundoNombre
      : "",
    primerApellido: usuario.datoPersonales
      ? usuario.datoPersonales.primerApellido
      : "",
    segundoApellido: usuario.datoPersonales
      ? usuario.datoPersonales.segundoApellido
      : "",
    telefonos: usuario.datoPersonales
      ? usuario.datoPersonales.ClienteTelefonos
      : [{ telefono: "" }],
    direcciones: usuario.datoPersonales
      ? usuario.datoPersonales.ClienteDireccions
      : [{ direccion: "", longitud: null, latitud: null }],
    genero: usuario.datoPersonales ? usuario.datoPersonales.genero : "",
    activo: true,
    imagen: usuario.datoPersonales
      ? usuario.datoPersonales.imagen
      : "cliente.jpeg",
    tipoUsuario: "Cliente",
  });
  const generos = [
    { value: 1, label: "Masculino" },
    { value: 2, label: "Femenino" },
  ];

  const [urlImagen, setUrlImagen] = useState(ImagenCliente + "clientes.jpeg");
  const [errorRtn, setErrorRtn] = useState(false);
  const [errorIdentidad, setErrorIdentidad] = useState(false);
  const [errorPrimerNombre, setErrorPrimerNombre] = useState(false);
  const [errorSegundoNombre, setErrorSegundoNombre] = useState(false);
  const [errorPrimerApellido, setErrorPrimerApellido] = useState(false);
  const [errorSegundoApellido, setErrorSegundoApellido] = useState(false);
  const [errorCorreo, setErrorCorreo] = useState(false);
  const [errorTelefonos, setErrorTelefonos] = useState([]);

  useEffect(() => {
    if (seleccionarDireccion) {
      setIsModalOpen(false);
      //agregarDireccion();
      console.log(formularioClientes.direcciones.length);
      setFormularioClientes((prevState) => ({
        ...prevState,
        direcciones: [...prevState.direcciones, nuevaDireccion],
      }));
      setSeleccionarDireccion(false);
      //setNuevaDireccion({ direccion: "Dirección: H5V4+2Q2, Siguatepeque, Siguatepeque, Departamento de Comayagua, Honduras", longitud: -87.84306461526864, latitud: 14.592255371946488 });
    }
  }, [seleccionarDireccion]);

  useEffect(() => {
    setErrorCorreo(!regexEmail.test(formularioClientes.correo));
    setErrorPrimerNombre(formularioClientes.primerNombre.length < 3);
    setErrorPrimerApellido(formularioClientes.primerApellido.length < 3);
    if (formularioClientes.segundoNombre) {
      setErrorSegundoNombre(
        !regexNombreVacio.test(formularioClientes.segundoNombre)
      );
    }

    if (formularioClientes.segundoApellido) {
      setErrorSegundoApellido(
        !regexNombreVacio.test(formularioClientes.segundoApellido)
      );
    }

    if (formularioClientes.rtn) {
      setErrorRtn(!regexRTN.test(formularioClientes.rtn));
    } else {
      setErrorRtn(false);
    }
    if (formularioClientes.identidad) {
      setErrorIdentidad(!regexIdentidad.test(formularioClientes.identidad));
    } else {
      setErrorIdentidad(false);
    }
    const nuevosErrores = formularioClientes.telefonos.map((numero) =>
      !regexTelefono.test(numero.telefono)
    );
    setErrorTelefonos(nuevosErrores);
  }, [formularioClientes]);

  // Estado para el género seleccionado en el Select
  const [generoId, setGeneroId] = useState(
    usuario.datoPersonales
      ? generos.find((opcion) => opcion.label === usuario.datoPersonales.genero)
        ?.value || null
      : null
  );

  // Efecto para sincronizar el género en formularioClientes
  useEffect(() => {
    const genero = generoId
      ? generos.find((opcion) => opcion.value === generoId)?.label
      : "";
    setFormularioClientes((prevState) => ({
      ...prevState,
      genero: genero,
    }));
  }, [generoId]);

  useEffect(() => {
    if (modalIsOpen) {
      setFormularioClientes({
        id: usuario.datoPersonales ? usuario.datoPersonales.id : null,
        correo: usuario ? usuario.correo : "",
        rtn: usuario.datoPersonales ? usuario.datoPersonales.rtn : "",
        identidad: usuario.datoPersonales
          ? usuario.datoPersonales.identidad
          : "",
        primerNombre: usuario.datoPersonales
          ? usuario.datoPersonales.primerNombre
          : "",
        segundoNombre: usuario.datoPersonales
          ? usuario.datoPersonales.segundoNombre
          : "",
        primerApellido: usuario.datoPersonales
          ? usuario.datoPersonales.primerApellido
          : "",
        segundoApellido: usuario.datoPersonales
          ? usuario.datoPersonales.segundoApellido
          : "",
        telefonos: usuario.datoPersonales
          ? usuario.datoPersonales.ClienteTelefonos
          : [{ telefono: "" }],
        direcciones: usuario.datoPersonales
          ? usuario.datoPersonales.ClienteDireccions
          : [{ direccion: "", longitud: null, latitud: null }],
        genero: usuario.datoPersonales ? usuario.datoPersonales.genero : "",
        activo: true,
        imagen: usuario.datoPersonales
          ? usuario.datoPersonales.imagen
          : "cliente.jpeg",
        tipoUsuario: "Cliente",
      });
    }
  }, [modalIsOpen]);

  const manejadorClientes = (event) => {
    setFormularioClientes({
      ...formularioClientes,
      [event.target.name]: event.target.value,
    });
  };

  const manejarCambioNumeros = (index, value) => {
    const nuevosNumeros = [...formularioClientes.telefonos];
    nuevosNumeros[index] = { telefono: value };

    setFormularioClientes({
      ...formularioClientes,
      telefonos: nuevosNumeros,
    });
  };

  const agregarNumero = () => {
    setFormularioClientes((prevState) => ({
      ...prevState,
      telefonos: [...prevState.telefonos, { telefono: "" }],
    }));
  };
  const eliminarNumero = (index) => {
    setFormularioClientes((prevState) => {
      const nuevosNumeros = [...prevState.telefonos];
      nuevosNumeros.splice(index, 1);
      return { ...prevState, telefonos: nuevosNumeros };
    });
  };

  const eliminarDireccion = (index) => {
    setFormularioClientes((prevState) => {
      const nuevasDirecciones = [...prevState.direcciones];
      nuevasDirecciones.splice(index, 1);
      return { ...prevState, direcciones: nuevasDirecciones };
    });
  };
  const BotonEditar = () => {
    return (
      <button type="button" className="btn btn-warning" onClick={editarCliente}>
        Editar
        <i className="fas fa-edit mr-1 mx-1" />
      </button>
    );
  };
  const editarCliente = () => {
    if (
      errorPrimerNombre ||
      errorSegundoNombre ||
      errorPrimerApellido ||
      errorSegundoApellido ||
      errorIdentidad ||
      errorCorreo
    ) {
      mostraAlertaWarning("Existen errores en la introducción de campos");
    } else {
      try {
        AxiosPrivado.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${token}`;
        AxiosPrivado.put(
          ClientesEditar + formularioClientes.id,
          formularioClientes
        )
          .then((respuesta) => {
            mostraAlertaOk("Registro actualizado correctamente");
            setModalIsOpen(false); // Cierra el modal
          })
          .catch((er) => {
            console.log(er);
            let msjError = "";
            switch (er.response.status) {
              case 400:
                if (er.response.data && Array.isArray(er.response.data)) {
                  er.response.data.forEach((f) => {
                    msjError += f.msg + ". ";
                  });
                } else {
                  msjError = er.response.data.error;
                }
                break;
              case 500:
                msjError = er.response.data.error;
                break;
              default:
                msjError = "Ocurrió un error desconocido.";
                break;
            }
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        mostraAlertaError("Error en la pedición");
      }
    }
  };
  const handleFileChange = async (event) => {
    const fileObj = event.target.files && event.target.files[0];
    if (!fileObj) {
      return;
    } else {
      try {
        let formData = new FormData();
        formData.append("imagen", event.target.files[0]);
        await AxiosImagen.put(
          ClienteImagenEditar + formularioClientes.id,
          formData
        )
          .then((respuesta) => {
            console.log(respuesta);
            setFormularioClientes((prevState) => ({
              ...prevState,
              imagen: respuesta.data.imagen,
            }));
            mostraAlertaOk("Imagen actualizada correctamente");
          })
          .catch((er) => {
            console.error("Error completo:", er);
            const { response } = er;
            const msjError =
              response?.data?.msj ||
              response?.data?.error?.message ||
              response?.data?.error ||
              "Ocurrió un error desconocido.";
            mostraAlertaError(msjError, "error");
          });
      } catch (error) {
        console.log(error);
        mostraAlertaError("Error al actualizar la imagen");
      }
    }
  };

  const SeleccionarImagen = () => {
    // 👇️ open file input box on click of another element
    console.log("Haciendo clic en SeleccionarImagen");
    if (inputRef.current) {
      inputRef.current.click();
    }
  };

  const inputRef = useRef(null);

 //console.log(formularioClientes);

  return (
    <ModalBootstrap
      titulo="Editar Perfil"
      nombreBoton="Editar"
      estiloBoton="btn btn-warning"
      iconBoton="fas fa-edit"
      pie={<BotonEditar />}
      modalIsOpen={modalIsOpen}
      setModalIsOpen={setModalIsOpen}
    >
      <div className="row">
        <div className="col-sm-4 col-lg-2">
          <div className="form-group">
            <div className="text-center">
              <img
                className="product-image"
                src={ImagenCliente + formularioClientes.imagen}
                alt="Foto"
                crossOrigin="anonymous"
              />
            </div>
            <input
              type="file"
              style={{ display: "none" }}
              ref={inputRef}
              onChange={handleFileChange}
            />
            <button
              type="button"
              className="btn btn-block btn-outline-info btn-xs"
              onClick={SeleccionarImagen}
            >
              Actualizar
            </button>
          </div>
        </div>

        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputRtn">RTN</label>
            <input
              type="text"
              className={`form-control ${errorRtn ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese el rtn"
              name="rtn"
              value={formularioClientes.rtn}
              onChange={manejadorClientes}
            />
            {errorRtn && (
              <div className="invalid-feedback">
                El RTN debe tener exactamente 14 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-8 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputRtn">Identidad</label>
            <input
              type="text"
              className={`form-control ${errorIdentidad ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese la identidad"
              name="identidad"
              value={formularioClientes.identidad}
              onChange={manejadorClientes}
            />
            {errorIdentidad && (
              <div className="invalid-feedback">
                La identidad debe tener exactamente 13 dígitos.
              </div>
            )}
          </div>
        </div>
        <div className="col-sm-12 col-lg-5">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Correo</label>
            <input
              type="text"
              className={`form-control ${errorCorreo ? "is-invalid" : ""}`}
              id="text"
              placeholder="Ingrese el correo"
              name="correo"
              value={formularioClientes.correo}
              onChange={manejadorClientes}
            />
            {errorCorreo && (
              <div className="invalid-feedback">
                Correo electrónico inválido
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerNombre">Primer Nombre</label>
            <input
              type="text"
              className={`form-control ${errorPrimerNombre ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Primer Nombre"
              name="primerNombre"
              value={formularioClientes.primerNombre}
              onChange={manejadorClientes}
            />
            {errorPrimerNombre && (
              <div className="invalid-feedback">
                El primer nombre debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>

        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoNombre">Segundo Nombre</label>
            <input
              type="text"
              className={`form-control ${errorSegundoNombre ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Segundo Nombre"
              name="segundoNombre"
              value={formularioClientes.segundoNombre}
              onChange={manejadorClientes}
            />
            {errorSegundoNombre && (
              <div className="invalid-feedback">
                El segundo nombre debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="primerApellido">Primer Apellido</label>
            <input
              type="text"
              className={`form-control ${errorPrimerApellido ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Primer Apellido"
              name="primerApellido"
              value={formularioClientes.primerApellido}
              onChange={manejadorClientes}
            />
            {errorPrimerApellido && (
              <div className="invalid-feedback">
                El primer apellido debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-3 col-sm-6">
          <div className="form-group">
            <label htmlFor="segundoApellido">Segundo Apellido</label>
            <input
              type="text"
              className={`form-control ${errorSegundoApellido ? "is-invalid" : ""
                }`}
              id="text"
              placeholder="Segundo Apellido"
              name="segundoApellido"
              value={formularioClientes.segundoApellido}
              onChange={manejadorClientes}
            />
            {errorSegundoApellido && (
              <div className="invalid-feedback">
                El segundo apellido debe tener al menos 3 caracteres.
              </div>
            )}
          </div>
        </div>
      </div>
      {/*Numeros de telefonos */}
      <div className="row">
        <div className="col-sm-12 col-md-6">
          <label>Teléfonos</label>
          <div className="row">
            <div className="col-sm-9">
              <div className="form-group">
                {formularioClientes.telefonos.map((numero, index) => (
                  <div key={index} className="input-group mb-3">
                    <input
                      type="text"
                      className={`form-control ${errorTelefonos[index] ? "is-invalid" : ""}`}
                      name="telefono"
                      value={numero.telefono}
                      onChange={(event) =>
                        manejarCambioNumeros(index, event.target.value)
                      }
                    />
                    {errorTelefonos[index] && (
                      <div className="invalid-feedback">
                        Número inválido. Debe tener entre 8 y 12 dígitos.
                      </div>
                    )}
                    {formularioClientes.telefonos.length > 1 && (
                      <button
                        type="button"
                        className="btn btn-danger mx-2"
                        onClick={() => eliminarNumero(index)}
                        width="20px"
                      >
                        <i className="fa fa-minus" aria-hidden="true"></i>
                      </button>
                    )}
                  </div>
                ))}
              </div>
            </div>
            <div className="col-sm-3">
              <button
                type="button"
                className="btn btn-block btn-primary"
                onClick={agregarNumero}
              >
                <i className="fa fa-plus" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      {/*Direcciones */}
      <div className="row">
        <div className="col-12">
          <label>Direcciones</label>
          <div className="pb-3">
            <GestionUbicacion
              direccion={nuevaDireccion}
              setDireccion={setNuevaDireccion}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setSeleccionarDireccion={setSeleccionarDireccion}
              textoBoton={"Agregar Ubicación"}
              verdireccion={false}
            />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            {formularioClientes.direcciones.map((f, index) => (
              <div key={index} className="row">
                <div className="col-9">
                  <p className="text-muted">{f.direccion}</p>
                </div>
                <div className="col-3">
                  <VerUbicacion key={index} direccion={f} />
                  <button
                    type="button"
                    className="btn btn-danger mx-2"
                    onClick={() => eliminarDireccion(index)}
                  >
                    <i className="fa fa-minus" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-4">
          <div className="form-group">
            <label htmlFor="exampleInputEmail1">Genero</label>
            <select
              className="form-control select2bs4"
              style={{ width: "100%" }}
              value={generoId || ""}
              onChange={(e) => {
                setGeneroId(e.target.value);
              }}
            >
              <option value="">Seleccione un género</option>
              {generos.map((genero) => (
                <option key={genero.value} value={genero.value}>
                  {genero.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </ModalBootstrap>
  );
};
export default ModalClientes;
